import { downloadTagItemsByTagFieldId } from '@/service/formManagementService';

const downloadTagItems = async ({
    corporationInuseId,
    projectInuseId,
    userInuseId,
    tagFieldDownloaderId
}) => {
    const reponse = await downloadTagItemsByTagFieldId({
        corporationInuseId,
        projectInuseId,
        userInuseId,
        tagFieldId: tagFieldDownloaderId
    });
    return reponse
};

export { downloadTagItems };
